import {
  ReactNode,
  useEffect,
  useMemo,
  useReducer,
} from 'react';
import { AccessibilityContext } from './accessibility-context';
import {
  accessibilityInitialState,
  accessibilityReducer,
} from './accessibility-reducer';
import { ACCESSIBILITY_STORAGE_KEY } from '../../constants/accessibility/accessibility.constants';


interface AccessibilityProviderProps {
  children: ReactNode;
}

export function AccessibilityProvider({
  children,
}: AccessibilityProviderProps) {
  const [state, dispatch] = useReducer(
    accessibilityReducer,
    accessibilityInitialState
  );


  // Carrega preferências salvas
  useEffect(() => {
    const savedAccessibility = localStorage.getItem(
      ACCESSIBILITY_STORAGE_KEY
    );

    if (savedAccessibility) {
      const parsedState = JSON.parse(savedAccessibility);

      if (parsedState.highContrast) {
        document.body.classList.add('high-contrast');
      }

      if (savedAccessibility) {
        const parsedState = JSON.parse(savedAccessibility);

        if (parsedState.highContrast) {
          document.body.classList.add('high-contrast');
        }

        if (parsedState.readerMode) {
          document.body.classList.add('reader-mode');
        }

        document.documentElement.style.setProperty(
          '--font-scale',
          String(parsedState.fontScale)
        );
      }
    }
  }, []);


  // Persiste alterações
  useEffect(() => {
    localStorage.setItem(
      ACCESSIBILITY_STORAGE_KEY,
      JSON.stringify(state)
    );


    // Alto contraste
    if (state.highContrast) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }

    if (state.readerMode) {
      document.body.classList.add('reader-mode');
    } else {
      document.body.classList.remove('reader-mode');
    }


    document.documentElement.style.setProperty(
      '--font-scale',
      String(state.fontScale)
    );

  }, [state]);

  const value = useMemo(() => {
    return {
      state,
      dispatch,
    };
  }, [state]);

  return (
    <AccessibilityContext.Provider value={value}>
      {children}
    </AccessibilityContext.Provider>
  );
}